module.exports = __webpack_public_path__ + "static/biosxan-8186b72fee58aa0ce053c1ce26a3e7b2.jpg";